import React from 'react';
import { FaEye, FaDatabase, FaFileInvoiceDollar, FaHistory, FaCog, FaSignOutAlt, FaUser } from 'react-icons/fa';

function Sidebar({ activeSection, setActiveSection, handleSignOut, isAdmin }) {
  // Definimos qué items son solo para admins
  const allNavItems = [
    { id: 'viewData', text: 'Visualizar Datos', icon: FaEye, adminOnly: false },
    { id: 'updateDatabase', text: 'Actualizar Base de Datos', icon: FaDatabase, adminOnly: false },
    { id: 'updatePrices', text: 'Actualizar Precios', icon: FaFileInvoiceDollar, adminOnly: false },
    { id: 'history', text: 'Historial', icon: FaHistory, adminOnly: false },
    { id: 'userManagement', text: 'Gestionar Usuarios', icon: FaUser, adminOnly: true }, // NUEVO
    { id: 'configuration', text: 'Configuración', icon: FaCog, adminOnly: true }
  ];

  // Filtramos los items basados en el rol del usuario
  const navItems = allNavItems.filter(item => !item.adminOnly || isAdmin);

  return (
    <aside className="sidebar">
      <div className="sidebar-header"><span className="sidebar-text">Menú</span></div>
      <nav className="sidebar-nav main-nav">
        <ul>
          {navItems.map(item => (
            <li key={item.id}>
              <button
                className={activeSection === item.id ? 'active' : ''}
                onClick={() => setActiveSection(item.id)}
              >
                <item.icon className="sidebar-icon" />
                <span className="sidebar-text">{item.text}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
      <nav className="sidebar-nav footer-nav">
        <ul>
          <li>
            <button onClick={handleSignOut}><FaSignOutAlt className="sidebar-icon" /><span className="sidebar-text">Cerrar Sesión</span></button>
          </li>
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar;